"use strict";

import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
export var label = _7a468({
  defaultClassName: "Label_label__1z0xvkh0",
  variantClassNames: {
    secondary: {
      true: "Label_label_secondary_true__1z0xvkh1"
    },
    align: {
      left: "Label_label_align_left__1z0xvkh2",
      center: "Label_label_align_center__1z0xvkh3"
    },
    size: {
      s: "Label_label_size_s__1z0xvkh4",
      m: "Label_label_size_m__1z0xvkh5",
      l: "Label_label_size_l__1z0xvkh6"
    },
    "long": {
      true: "Label_label_long_true__1z0xvkh7"
    },
    hidden: {
      true: "VisuallyHidden_visuallyHidden__1239gr90"
    },
    disabled: {
      true: "Label_label_disabled_true__1z0xvkh9"
    },
    truncate: {
      true: "Label_label_truncate_true__1z0xvkha"
    }
  },
  defaultVariants: {},
  compoundVariants: [[{
    size: "s",
    "long": true
  }, "Label_label_compound_0__1z0xvkhb"], [{
    size: "m",
    "long": true
  }, "Label_label_compound_1__1z0xvkhc"], [{
    size: "l",
    "long": true
  }, "Label_label_compound_2__1z0xvkhd"]]
});